import { render } from "./work-orders-history.vue?vue&type=template&id=c57f57ea"
import script from "./work-orders-history.vue?vue&type=script&lang=js"
export * from "./work-orders-history.vue?vue&type=script&lang=js"

import "./work-orders-history.vue?vue&type=style&index=0&id=c57f57ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__